import AddEditParentOrganization from './AddEditParentOrganization';

export default AddEditParentOrganization;